<template>
  <div v-loading="loading">
    <h3 class="inviteAddEm">给海外目标客户发送邀请参观登记的英文邮件</h3>
    <div class="inviteMain">
      <div class="inviteCon">
        <!--<p>{{inviteTex}}</p>-->
        <div class="radioType">
          <!--<el-radio v-model="radio" label="1" v-if="emailInvite">邮件邀请</el-radio>-->
          <!--<el-radio v-model="radio" label="2" v-if="QRCodeInvited">微信邀请</el-radio>-->
        </div>
        <div class="type" v-show="radio==='1'">
          <!-- <h4>邀请方式1：邮件邀请</h4> -->
          <el-form ref="form" class="inviteForm" :model="form" label-width="80px">
            <el-form-item label="发件人">
              <el-input :disabled="true" v-model="form.name" placeholder="请在“填充展商信息”页面输入企业英文名称"></el-input>
            </el-form-item>
            <el-form-item label="E-mail">
              <el-input v-model="form.emails" placeholder="请输入受邀观众的邮箱"></el-input>
              <span>发给多个收件人，请将邮箱用英文逗号隔开</span>
            </el-form-item>
            <el-form-item label="邮件标题">
              <el-input :disabled="true" v-model="form.title" style="width:200%;"></el-input>
            </el-form-item>
            <el-form-item label="发送内容">
              <div class="inviteEmailCon" v-html="form.emailCon"></div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="sendEmail" :style="btnAllStyle">即刻发送邀请邮件</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--<div v-show="radio === '2'">
          <p style="padding:30px 0;">点击下方“即刻邀请好友”，手机扫描二维码获取电子邀请函，转发给好友或朋友圈即可邀请好友预登记；</p>
          <div class="inviteBtnbox"><el-button type="primary" :style="btnAllStyle" @click="showInviteModal = true">即刻邀请好友</el-button></div>
        </div>-->
      </div>
    </div>
    <!--<el-dialog
      :visible.sync="showInviteModal"
      width="800px">
      <div class="inviteModalCon">
        <div class="inviteLeft">
          <div class="qrBox">
            <div id="qrCode" ref="qrCodeDiv"></div>
          </div>
          <div>
            <h5>微信扫描二维码，获取专属邀请函</h5>
            <p class="shareTipsP">然后点击右上角'...'，转发给朋友或朋友圈</p>
          </div>
        </div>
        <div class="inviteRight" v-if="QRCodeBanner">
          <img :src="QRCodeBanner" alt="">
        </div>
      </div>
    </el-dialog>-->
  </div>
</template>
<script>
//import Nav from '../components/Nav'
import QRCode from 'qrcodejs2'
import api from '@/api'
import regExp from '@/utils/regExp'
export default {
  name: 'invite',
  components: {
//  Nav
  },
  data() {
    return {
      radio: '1',
      form: {
        name: '',
        emails: '',
        title: '',
        emailCon: ''
      },
      showInviteModal: false,
      QRCodeBanner: '',
      ExhID: sessionStorage.getItem('ExhID'),
      inviteTex: '',
      msgInvite: true,
      emailInvite: true,
      QRCodeInvited: true,
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      emailsArr:[],
      NameAndEmail:{
        email:'',
        name:''
      },
      loading:false
    }
  },
  watch: {
    showInviteModal(val1, val2) {
      setTimeout(() => {
        if (val1 === true) {
          this.bindQRCode()
        }
      }, 100);
    }
  },
  mounted() {
    this.getinvitestrategy()
//  this.loadPageConfig()
  },
  methods: {
    getinvitestrategy() {
      var inviteUrl = ''
      var InviteType = sessionStorage.getItem('InviteType') || 'Person'
      let InviteCode = sessionStorage.getItem('InviteCode') || 0
      let InviteID = sessionStorage.getItem('noJmPsnID');
      inviteUrl = `${window.location.href.split('#')[0]}#/login?ExhID=${sessionStorage.getItem('ExhID')}&InviteID=${InviteID}&InviteType=${InviteType}&InviteCode=${InviteCode}`;
      api.getinvitestrategy({
        atrLanguage:'en'
      }).then(res => {
        if (res.data.code === 200) {
          // console.log(localStorage.getItem('atrEName'))
          this.form.title = res.data.data.inviteTitle
          this.form.name = localStorage.getItem('atrEName')
          var htmlString = res.data.data.html
//        htmlString = htmlString.replace(/<a/, "<span");
//        htmlString = htmlString.replace(/<\/a>/, "</span>");
          // var replacedHtmlString = htmlString.replace(/<a(.*?)>(.*?)<\/a>/, '<div$1>$2</div>');
          // console.log(htmlString);
          this.form.emailCon = htmlString

  

        }
      })
    },
    sendEmail() {
      this.loading = true;
      if (!this.form.emails) {
        this.$alert('请输入至少一个邮箱！')
        this.loading = false;
        return false;
      } else {
        // 验证邮箱格式
        var tmpArr = this.form.emails.split(',')
        for (let i = 0; i < tmpArr.length; i++) {
          let tmpObj = tmpArr[i]
          if (!regExp.Email.test(tmpObj)) {
            this.$alert(`第${i + 1}个邮箱格式错误`)
            this.loading = false;
            return false;
          }
        }
      }
      // console.log(this.form.emails)
      let emailsStr = this.form.emails.split(',')
//    this.emailsArr = emailsStr.split(',')
      // console.log(this.emailsArr)
      this.emailsArr = []
      for (let i = 0; i < emailsStr.length; i++) {
        this.emailsArr.push({
          name:'',
          email : emailsStr[i]
        })
      }
      // console.log(this.emailsArr)
      var inviteUrl = ''
      var InviteType = sessionStorage.getItem('InviteType') || 'Person'
      let InviteCode = sessionStorage.getItem('InviteCode') || 0
      let InviteID = sessionStorage.getItem('noJmPsnID');
      inviteUrl = `${window.location.href.split('#')[0]}#/login?ExhID=${sessionStorage.getItem('ExhID')}&InviteID=${InviteID}&InviteType=${InviteType}&InviteCode=${InviteCode}`;
      // 发送邮件
      this.loading = true;
      api.addinvitemessage({
        receivers: this.emailsArr,
        Emails: this.form.emails,
        inviteTitle: this.form.title,
        message: '',
        atrLanguage:'en'
      }).then(res => {
        if (res.data.code === 200) {
          this.form.emails = ''
          this.$message({
            message: '邮件发送成功',
            type: 'success'
          });
          this.loading = false
          return false
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>

<style>
.inviteEmailCon{
  padding: 10px;
  background: #F5F7FA;
  border:1px solid #E4E7ED;
  width: 610px;
  border-radius: 6px;
}
.qrBox{
  display: inline-block;
}
.inviteAddEm{
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 30px 20px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.inviteMain{
  background: #fff;
  padding: 14px 80px;
}
.radioType{
  padding: 20px 0;
}
.inviteForm{
  padding-top: 10px;
  width: 50%;
}
.inviteCon{
  min-height: 500px;
}
.inviteBtnbox{
  text-align: center;
  padding: 30px 0;
}
.inviteModalCon{
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;
}
.inviteModalCon .inviteLeft{
  width: 280px;
  text-align: center;
}
.shareTipsP{
  font-size: 12px;
  color: #999;
}
.inviteRight img{
  width: 100%;
}
@media screen and (max-width:540px){
	.inviteAddEm{
		padding:0.5rem 0;
	}
	.inviteMain{
		padding: 0;
	}
	.inviteForm{
		width: 100%;
	}
	.el-form-item__label{
		font-size: 14px;
    text-align: left !important;
    float: none !important;
	}
	.el-form-item__content{
		margin-left: 0 !important;
	}
	.el-input{
		width: 100% !important;
	}
	.inviteEmailCon{
		width: 100% !important;
	}
}
</style>